import React from 'react';

import styles from './Numbers.module.css';

const Numbers = (props) => {
  // const [snNum, setSnNum] = useState(0);

  // useEffect(()=> {
  //   animateNumbers(props.stickyNotesNum)

  // }, [p]);

  // const animateNumbers = (total) => {
  //   let diff = total - snNum;
  //   while (diff > 0) {
  //     total = total - 1
  //     setSnNum(snNum + 1);
  //     console.log('diff', diff);
  //     console.log('total', total);
  //     console.log('snNum', snNum);
  //   }
  // };

  return (
    <div className={styles.numbersContainer}>
            <h2>totals:</h2>
      <div className={styles.stickyNotesLeft}>
        <p className={styles.number1}>{props.stickyNotesNum}</p>
      </div>
      <div className={styles.stickyNotesRight}>
        <p>sticky notes</p>
      </div>
      <div className={styles.categoriesLeft}>
        <p className={styles.number2}>{props.categoriesArray.length}</p>
      </div>
      <div className={styles.categoriesRight}>
        <p>categories</p>
      </div>
      <div className={styles.daysLeft}>
        <p className={styles.number3}>3650</p>
      </div>
      <div className={styles.daysRight}>
        <p>days</p>
      </div>
    </div>
  );
};

export default Numbers;
